'use client'

import { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'

import { TOAST_CONTAINER_TEST_IDS } from '@common/common-test-ids.const'

import { useToastStore } from '@stores/toast/toast.store'

import { ToastInstance } from './components/ToastInstance'

export function ToastContainer() {
  const toasts = useToastStore((state) => state.toasts)
  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => setIsMounted(true), [])

  if (!isMounted || typeof document === 'undefined') {
    return null
  }

  return createPortal(
    <div data-testid={TOAST_CONTAINER_TEST_IDS.root}>
      {toasts.map((toast) => (
        <ToastInstance key={toast.id} toast={toast} />
      ))}
    </div>,
    document.body
  )
}
